import React, { useRef, useState } from 'react';
import TorontoFooter from '../Layout/TorontoFooter';
import { Fragment } from 'react';
import SFFooter from '../Layout/SFFooter';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Mutation } from 'react-apollo';
import { WEBSITE_LOGIN } from './queries';
import { useHistory } from 'react-router-dom';
import { saveState } from '../../utils/localStorage';

const NewSignIn = ({ country }) => {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordType, setPasswordType] = useState('password');
  const [isEye, setIsEye] = useState(false);
  const [error, setError] = useState(false);

  const location = useLocation();
  const history = useHistory();
  const destination = location.state ? location.state.destination : "/"

  const websiteLoginRef = useRef(null);

  const toggleEye = () => {
    setIsEye(!isEye);
    if (passwordType === 'password') {
      setPasswordType('text');
    } else {
      setPasswordType('password');
    }
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && websiteLoginRef.current) {
      websiteLoginRef.current(); // Trigger websiteLogin function in the Mutation
    }
  };

  return (
    <Fragment>
      <div
        className="login-form-container"
        style={{ margin: '124px auto' }}>
        <div className="form-title">
          Log in
        </div>

        <div className='signup-field-name'>
          Username
        </div>
          
        <input value={email} onChange={handleEmailChange}
          className={error?"signup-text-input-error":"signup-text-input"} placeholder="Email or Phone Number"/>
        
        <div className='signup-field-name'>
          Password
        </div>
          
        <input value={password} onChange={handlePasswordChange}
          type={passwordType} autoComplete='off' className={error?"signup-text-input-error":"signup-text-input"} placeholder="Password" onKeyDown={handleKeyDown}/>


        <i
            onClick={toggleEye}
            className={`fa ${isEye ? 'fa-eye' : 'fa-eye-slash'}`}
            style={{
              cursor: 'pointer',
              position: 'relative',
              display: 'flex',
              paddingRight: '12px',
              left: '92%',
              bottom: '40px',
              width: '20px'
            }}></i>

        {error?<div className='login-error-message'>Invalid credentials</div>:""}
          
        {/* Add this when reset password is implemented */}
        {/* <Link className='login-forgot-password'>Forgot Password</Link> */}

        <Mutation mutation={WEBSITE_LOGIN} variables={{email:email, password,password}} onCompleted={(data)=>{
            const loginData = data && data.websiteLogin
            if (loginData.error){
                setError(true);
            }
            else {
                setError(false);
                saveState(loginData);
                history.push(destination);
            }
        }}>
            {(websiteLogin, { loading, error }) => {
              websiteLoginRef.current = websiteLogin;
              return(
                <div className="login-button"
                  onClick={() => {
                    websiteLogin()
                  }}
                >
                  Log in
                </div>)
            }}
          </Mutation>
        <div>Don’t have an account? <Link to="/signup">Sign up</Link></div>


        <div className="login-extra-info"> Download the Autzu app to manage or make new bookings.</div> 

      </div>
      {country === 'CA' ? <TorontoFooter /> : <SFFooter />}
    </Fragment>
  );
};

export default NewSignIn;


// WEBPACK FOOTER //
// ./src/components/NewSignIn/index.js